import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Getlist, GetFavorites, ToggleFavorite } from '../../services/advert';

export const fetchAdverts = createAsyncThunk(
  'adverts/fetchAdverts',
  async ({ filters = [], sortBy = 'CreatedDate', sortOrder = 'desc', pageIndex = 1, pageSize = 12 }, { rejectWithValue }) => {
    try {
      const filterParams = {
        filters: filters || [],
        sortBy: sortBy || 'CreatedDate',
        sortOrder: sortOrder || 'desc',
        pageIndex: pageIndex || 1,
        pageSize: pageSize || 12
      };
      
      const response = await Getlist(filterParams);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Bir hata oluştu');
    }
  }
);

export const fetchFavorites = createAsyncThunk(
  'adverts/fetchFavorites',
  async (_, { rejectWithValue }) => {
    try {
      const response = await GetFavorites();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Bir hata oluştu');
    }
  }
);

export const toggleFavorite = createAsyncThunk(
  'adverts/toggleFavorite',
  async ({ id, isFav }, { rejectWithValue }) => {
    try {
      await ToggleFavorite(id, isFav);
      return { id, isFav: !isFav };
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Bir hata oluştu');
    }
  }
);

const advertsSlice = createSlice({
  name: 'adverts',
  initialState: {
    listings: [],
    favorites: [],
    isLoading: false,
    error: null,
    hasMore: true,
    pageIndex: 1,
    totalPages: 0,
    filters: [],
    sortBy: 'CreatedDate',
    sortOrder: 'desc',
    latestRequestId: null
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.pageIndex = 1;
    },
    clearFilters: (state) => {
      state.filters = [];
      state.pageIndex = 1;
    },
    setPageIndex: (state, action) => {
      state.pageIndex = action.payload;
    },
    setSorting: (state, action) => {
      state.sortBy = action.payload.field;
      state.sortOrder = action.payload.order;
      state.pageIndex = 1;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdverts.pending, (state, action) => {
        // Üst üste istekler (filtre/sıralama/kayıtlı arama) — yalnızca en son isteğin yanıtı listeyi yazar
        state.latestRequestId = action.meta.requestId;
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAdverts.fulfilled, (state, action) => {
        if (state.latestRequestId && action.meta.requestId !== state.latestRequestId) return;
        state.isLoading = false;

        if (action.payload && action.payload.data) {
          state.listings = action.payload.data.items || [];
          state.totalPages = action.payload.data.totalPages || 0;
          state.hasMore = state.pageIndex < state.totalPages;
        } else {
          state.listings = [];
          state.totalPages = 0;
          state.hasMore = false;
        }
      })
      .addCase(fetchAdverts.rejected, (state, action) => {
        if (state.latestRequestId && action.meta.requestId !== state.latestRequestId) return;
        state.isLoading = false;
        state.error = action.payload || 'Bir hata oluştu';
        state.listings = [];
        state.totalPages = 0;
        state.hasMore = false;
      })
      
      .addCase(fetchFavorites.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFavorites.fulfilled, (state, action) => {
        state.isLoading = false;
        state.favorites = action.payload?.data || [];
      })
      .addCase(fetchFavorites.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Bir hata oluştu';
      })
      
      .addCase(toggleFavorite.fulfilled, (state, action) => {
        const { id, isFav } = action.payload;
        
        state.listings = state.listings.map(item => 
          item.id === id ? { ...item, isFav } : item
        );
        
        if (isFav) {
          const item = state.listings.find(item => item.id === id);
          if (item) {
            state.favorites.push(item);
          }
        } else {
          state.favorites = state.favorites.filter(item => item.id !== id);
        }
      });
  }
});

export const { setFilters, clearFilters, setPageIndex, setSorting } = advertsSlice.actions;
export default advertsSlice.reducer; 